import Inputmask from "inputmask";
import {mergeDeepObject} from "../../../../modules/vegas/js/util";

class VGInputMask {
	init(container) {
		let _this = this,
			elements = [...(container || document).querySelectorAll('[data-mask]')];

		elements.forEach((el => {
			let mask = el.dataset.mask,
				format, opts = {};

			switch (mask) {
				case 'phone':
					format = el.dataset.format || '8 (999) 999-99-99';
					opts = Object.assign({
						clearIncomplete: true,
						showMaskOnHover: true,
						onBeforeMask: function (pastedValue, opts) {
							return _this.normalize_phone(pastedValue)
						},
					}, opts);
					break;
				case 'phone-without-eight':
					format = el.dataset.format || '(999) 999-99-99';
					opts = mergeDeepObject({
						clearIncomplete: true,
						showMaskOnFocus: true,
						showMaskOnHover: false,
						onBeforeMask: function (pastedValue, opts) {
							return _this.normalize_phone(pastedValue)
						},
					}, opts);
					break;

				case 'code-6':
					format = el.dataset.format || '999999';
					break;
			}

			if (format) {
				let im = new Inputmask(format, opts);
				im.mask(el);
			}
		}));
	}

	normalize_phone(val) {
		return val.replace(new RegExp(/\D/, 'g'), '').split('').reverse().slice(0, 10).reverse().join('');
	}
}

export default VGInputMask;
